import { translateJSON } from "src/redux/slicers/translationCombinedSlice"
import store from "src/redux/Store"
import { TranslateClient } from "@aws-sdk/client-translate";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import config from "src/aws-exports";

// Singleton TranslateClient
let translateClient: TranslateClient | null = null;

export const getTranslateClient = async (): Promise<TranslateClient> => {
    if (!translateClient) {
        try {
            translateClient = new TranslateClient({
                region: config.aws_project_region,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: config.aws_project_region },
                    identityPoolId: config.aws_cognito_identity_pool_id
                }),
                // Optimize for faster requests
                maxAttempts: 3
            });
        } catch (error) {
            console.error("Error initializing TranslateClient: ", error);
            return null
        }
    }
    return translateClient;
};

export const executeWithRetry = async <T>(fn: () => Promise<T>, maxRetries = 2, initialDelay = 50): Promise<T> => {
    let retries = 0;
    let delay = initialDelay;

    while (true) {
        try {
            return await fn();
        } catch (error: any) {
            const isRateLimitError = error?.name === "TooManyRequestsException" ||
                error?.statusCode === 429 ||
                error?.message?.includes("rate limit") ||
                error?.message?.includes("Rate exceeded");

            const isTimeoutError = error?.name === "TimeoutError" ||
                error?.message?.includes("timeout") ||
                error?.message?.includes("did not complete");

            // Retry on rate limit or timeout errors
            if ((!isRateLimitError && !isTimeoutError) || retries >= maxRetries) {
                throw error;
            }

            const errorType = isTimeoutError ? "Timeout" : "Rate limited";
            console.log(`${errorType}, retrying in ${delay}ms. Retries left: ${maxRetries - retries}`);
            await new Promise(resolve => setTimeout(resolve, delay));
            retries++;
            delay *= 1.5; // Exponential backoff
        }
    }
};

// Function to translate JSON using Redux thunk
export const translateJSONInFile = async (json: Record<string, any>, pageNameKey?: any) => {
    try {
        // Dispatch the thunk and wait for the translated value
        const result = await store.dispatch<any>(translateJSON({ json, pageNameKey })).unwrap();
        return result;
    } catch (error) {
        console.error("Translation failed : ", error);
        throw error;
    }
}
